/**
 * Template-related constants
 */

export const ASSET_DRIVEN_TEMPLATE_TOOLTIP =
  'This template creates tasks based on selected assets';

/**
 * Asset type constant for "Other" - used in asset-driven templates
 * to match assets whose type is not covered by other task rules
 */
export const OTHER_ASSET_TYPE = 'Other';

/**
 * Group name constants for template grouping in Combolist
 * These ensure consistent grouping and sorting across components
 */
export const TEMPLATE_GROUP_ASSET_DRIVEN = 'Asset-Driven';
export const TEMPLATE_GROUP_TEMPLATES = 'Templates';
